const Loglar = resolve => {
    require.ensure(['../views/apps/loglar/Loglar'], () => {
        resolve(require('../views/apps/loglar/Loglar.vue'))
    })
};

import layouts from '../layout'
import Vue from 'vue'

Vue.component('loglar', Loglar);


export default {
    path: '/loglar',
    name: 'loglar',
    component: Loglar,
    meta: {
        layout: layouts.navLeft
    }

}